export const PAGE_SIZE = 10;

export const firstText = (...values: unknown[]): string => {
  const found = values.find(
    (value) => value !== undefined && value !== null && value !== '',
  );

  return found === undefined ? '' : String(found);
};

export const firstNumber = (...values: unknown[]): number | undefined => {
  const found = values.find(
    (value) =>
      typeof value === 'number' ||
      (typeof value === 'string' && value !== '' && !Number.isNaN(Number(value))),
  );

  return found === undefined ? undefined : Number(found);
};

export const asRecord = (value: unknown): Record<string, unknown> | null =>
  value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;

export const readNegotiationPage = (
  payload: unknown,
): { items: Record<string, unknown>[]; totalPages: number } => {
  const record = asRecord(payload);
  const nested = asRecord(record?.data);
  const source = nested ?? record;
  const listKeys = ['content', 'negociacoes', 'items', 'acordos', 'lista', 'data'];
  const fromKeys = listKeys
    .map((key) => source?.[key] ?? record?.[key])
    .find(Array.isArray) as Record<string, unknown>[] | undefined;
  let items: Record<string, unknown>[] = fromKeys ?? [];

  if (Array.isArray(payload)) {
    items = payload as Record<string, unknown>[];
  } else if (Array.isArray(record?.data)) {
    items = record.data as Record<string, unknown>[];
  }

  const totalPages = firstNumber(
    source?.totalPages,
    source?.totalPaginas,
    record?.totalPages,
    record?.totalPaginas,
  );
  const totalItems = firstNumber(
    source?.totalElements,
    source?.totalItems,
    source?.total,
    record?.totalElements,
    record?.totalItems,
    record?.total,
  );
  let pages = items.length ? 1 : 0;

  if (totalPages && totalPages > 0) {
    pages = totalPages;
  } else if (totalItems && totalItems > 0) {
    pages = Math.ceil(totalItems / PAGE_SIZE);
  }

  return { items, totalPages: pages };
};
